import { render, staticRenderFns } from "./detailsOld.vue?vue&type=template&id=55a8d7ac&scoped=true&"
import script from "./detailsOld.vue?vue&type=script&lang=js&"
export * from "./detailsOld.vue?vue&type=script&lang=js&"
import style0 from "./detailsOld.vue?vue&type=style&index=0&id=55a8d7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8d7ac",
  null
  
)

export default component.exports